import React, {  } from "react";
import "./404.css";
import "./../header/header.css";

import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

const NotFound = () => {
  const { t } = useTranslation();
  return (
    <section className="banner py-5 position-relative">
      <div className="container py-md-5 pt-5 px-4">
        <div
          className="row justify-content-center align-items-center"
          style={{ minHeight: "90vh" }}
        >
          <div className="col-md-12">
            <div className="error-template text-center">
              <h1 className="fw-bold display-2 mt-5 mt-md-2">{t("404H1")}</h1>
              <h2 >{t("404H2")}</h2>
              <div className="error-details">
              {t("404H3")}
              </div>
              <div className="error-actions mt-2 mb-4">
                <Link to={"/unlock-phone"} >
                  <button className="btn btn-outline-light order-status x404">
                  {t("404B1")}
                  </button>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
export default NotFound;
